import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ObjectInspector } from 'react-inspector';

class RawJson extends PureComponent {
  render() {
    const { object, theme, expandLevel } = this.props;
    return (
      <div className="dashboard">
        <div style={{
          height: 'inherit',
          overflow: 'scroll',
        }}
        >
          <ObjectInspector
            data={object}
            theme={theme}
            expandLevel={expandLevel}
          />
        </div>
      </div>
    );
  }
}

RawJson.defaultProps = {
  object: {},
  theme: 'chromeDark',
  expandLevel: 2,
};

RawJson.propTypes = {
  object: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  theme: PropTypes.string,
  expandLevel: PropTypes.number,
};

export default RawJson;
